import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom'
import colors from 'utils/styling/colors'
import zLayers from 'utils/styling/zLayers'
import { NAVIGATION_HEIGHT } from 'components/global/Navigation/Navigation.styled'

const focusRing = css`
  &:focus-visible {
    outline: 2px solid ${colors('brand')};
    outline-offset: 2px;
  }
`

export const MenuButton = styled.span`
  display: flex;
  align-items: center;

  button {
    border-radius: 6px;
    ${focusRing}
  }
`

// Fixed flush under the admin bar and portalled to the body, outside the
// page's own stacking contexts, so it paints over any page content whose
// z-index is not above zLayers.menu.
export const Panel = styled.nav`
  position: fixed;
  top: ${NAVIGATION_HEIGHT};
  bottom: 0;
  left: 0;
  z-index: ${zLayers.menu};
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 256px;
  padding: 16px;
  overflow-y: auto;
  overscroll-behavior: contain;
  background: ${colors('white')};
  border-right: 1px solid ${colors('gray4')};
  box-shadow: 4px 0 16px ${colors('almostBlack', 10)};
`

export const HomeTile = styled(Link)`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  margin-bottom: 8px;
  border-radius: 8px;
  color: ${colors('gray1')};
  text-decoration: none;
  ${focusRing}

  &:hover {
    background: ${colors('gray5')};
  }
`

export const HomeMark = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 8px;
  background: ${colors('secondary')};
  color: ${colors('lockedWhite')};
  font-family: 'Playfair Display', serif;
  font-weight: 700;
`

export const HomeLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
`

export const Groups = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const GroupLabel = styled.span`
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 500;
  color: ${colors('gray2')};
`

export const Item = styled(Link)<{ $active: boolean }>`
  position: relative;
  padding: 8px 24px;
  border-radius: 6px;
  font-size: 14px;
  text-decoration: none;
  color: ${colors('gray1')};
  font-weight: ${({ $active }) => ($active ? 600 : 500)};
  ${focusRing}

  &:hover {
    background: ${colors('gray5')};
  }

  ${({ $active }) =>
    $active &&
    css`
      background: ${colors('paleSecondary')};

      &::before {
        content: '';
        position: absolute;
        top: 6px;
        bottom: 6px;
        left: 8px;
        width: 3px;
        border-radius: 2px;
        background: ${colors('secondary')};
      }
    `}
`

export const BackLink = styled(Link)`
  margin-top: auto;
  padding: 8px 12px;
  border-top: 1px solid ${colors('gray4')};
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  color: ${colors('gray2')};
  ${focusRing}

  &:hover {
    color: ${colors('gray1')};
  }
`
